<template>
  <div class="d-flex flex-column h-100 justify-content-between align-content-center">
    <nav class="navbar navbar-expand-lg sticky-top navbar-light bg-white border-bottom">
      <div class="container-fluid">
        <DotIncorporationLogo />
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu, #navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2">
          </ul>
          <div class="d-flex justify-content-end">
<!--            <button class="nav-link gap-3 d-flex border-0 bg-white" @click="signOut()">-->
<!--              Sign out-->
<!--            </button>-->
          </div>
        </div>
      </div>
    </nav>
    <div class="flex-grow-1 d-flex flex-column flex-sm-row w-100" style="min-height: 0">
      <nav
        id="sidebarMenu"
        class="d-md-block bg-white collapse"
        style="z-index: 999; width: 15rem"
      >
        <div class="position-sticky">
          <LeftMenu></LeftMenu>
        </div>
      </nav>
      <main class="ms-sm-auto px-4 overflow-auto d-flex flex-column flex-grow-1 align-content-center w-100">
        <router-view />
      </main>
    </div>
    <footer class="d-grid bg-light d-flex justify-content-center p-3 sticky-bottom text-center">
      Copyright©{{ copyRightYear }} Dot Incorporation. All rights reserved. Terms&Condition Privacy Policy
    </footer>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import LeftMenu from "./LeftMenu"
import { $global, $session } from "@/dot-ui/index.js";
import { router } from "@/routes/index.js";

const DotIncorporationLogo = defineAsyncComponent(() => import('@/components/molecules/DotIncorporationLogo.vue'))

export default {
  components: {
    DotIncorporationLogo,
    LeftMenu,
  },
  computed: {
    copyRightYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    // 로그아웃
    signOut() {
      // 토큰 쿠키에서 삭제
      $session.removeCookies();
      // 로그인 URL로 이동
      const fromParams = $global.getUrlParams();

      router.push({
        path : "/login",
        query: {
          cb: fromParams.cb,
          s: fromParams.s,
          c: fromParams.c
        },
      });
    },
  },
}
</script>
<style>
.nav-link {
  color: black;
}
.nav-link:hover{
	color: black;
	background-color: rgb(235, 235, 235);
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
	background-color: black;
}
.nav-link:focus{
	background-color: rgb(199, 199, 199);
}
</style>
